import React from 'react';
import {connect} from 'react-redux';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {useRegionLabels} from 'app/shared/hooks/useRegionLabels';
import {setRegistrationData} from 'app/entities/registration/registration.reducer';
import RegistrationButtons from './registration-buttons';
import 'app/entities/registration/registration.scss';

export enum LocationTypeEnum {
  COMMUNITY = 'Community',
  HEALTH_FACILITY = 'Health Facility',
}

interface ILocationTypeProps extends StateProps, DispatchProps {
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  currentStep: number;
}

const LocationType = (props: ILocationTypeProps) => {
  const {locationType} = props;

  const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedLocation = e.target.value as LocationTypeEnum;
    // If selected location is facility set village info in registration data to null and vice versa
    if (selectedLocation === LocationTypeEnum.HEALTH_FACILITY) {
      props.setRegistrationData({locationType: selectedLocation, villageId: null, village: null});
    } else {
      props.setRegistrationData({locationType: selectedLocation, healthcareFacilityId: null, healthcareFacility: null});
    }
  };



  return (
    <div>
      <h2 className="mb-4">Where are you calling from?</h2>
      <AvForm onValidSubmit={props.handleNextStep}>
        <AvRadioGroup name="radio-button-group" required value={locationType} errorMessage="Please select an option">
          <Row className="d-flex justify-content-between align-items-center">
            {Object.values(LocationTypeEnum).map(type => (
              <Col md="6" key={type}>
                <Label className="radio-button-label">
                  <AvRadio name="location" value={type} onClick={handleLocationChange} className="radio-button-input"/>
                  {type}
                </Label>
              </Col>
            ))}
          </Row>
        </AvRadioGroup>
        <RegistrationButtons
          currentStep={props.currentStep}
          handlePreviousStep={props.handlePreviousStep}
        />
      </AvForm>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  locationType: state.registration.entity.locationType,
});

const mapDispatchToProps = {
  setRegistrationData,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(LocationType);
